import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
const db = firebase.firestore()

const state = {
  bodies: [],
  body: [],
  bodyComponents: [],
  managers: [
    { text: 'Albina', value: 'albina', hidden: true },
    { text: 'Amina', value: 'amina' },
    { text: 'Aizhan', value: 'aizhan', hidden: true },
    { text: 'Galina', value: 'galina', hidden: true },
    { text: 'Nastya', value: 'nastya' },
    { text: 'Renat', value: 'renat' }
  ]
}

const actions = {
  GET_BODIES ({ commit }) {
    let resolved = false
    return new Promise((resolve, reject) => {
      let ref = db.collection('bodies')
      ref.onSnapshot(snapshot => {
        let bodies = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          bodies.push(log)
        })
        commit('SET_LOADED_BODIES', bodies)
        if (!resolved) {
          resolved = true
          resolve()
        }
      }, (error) => {
        reject(error)
      })
    })
  },
  CREATE_BODY ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload.body
      db.collection('bodies')
        .doc(String(data['slug']))
        .set(data)
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  },
  UPDATE_BODY ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload
      db.collection('bodies')
        .doc(data.slug)
        .update({
          title: data.title,
          createdAt: data.createdAt,
          slug: data.slug,
          isActive: data.isActive,
          isFree: data.isFree,
          description: data.description,
          shortDescription: data.shortDescription,
          logo: data.logo
        })
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  },
  GET_BODY ({ commit }, slug) {
    return new Promise((resolve, reject) => {
      let bodies = []
      db.collection('bodies')
        .doc(slug)
        .get()
        .then((doc) => {
          if (doc) {
            bodies.push(doc.data())
            commit('SET_MANAGERS_BODY', bodies[0])
            resolve(doc)
          }
        })
        .catch(reject)
    })
  },
  CREATE_BODY_CLASS ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('bodies')
        .doc(payload.bodySlug)
        .collection('components')
        .doc(String(payload.bodyClass.slug))
        .set(payload.bodyClass)
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  },
  UPDATE_BODY_CLASS ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload.bodyClass
      db.collection('bodies')
        .doc(payload.bodySlug)
        .collection('components')
        .doc(String(payload.bodyClass.slug))
        .update({
          title: data.title,
          createdAt: data.createdAt,
          slug: data.slug,
          isActive: data.isActive,
          components: data.components,
          icon: data.icon
        })
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  },
  ADD_BODY_COMPONENT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('bodies')
        .doc(payload.bodySlug)
        .collection('components')
        .doc(String(payload.bodyClass.slug))
        .update({
          components: firebase.firestore.FieldValue.arrayUnion(payload.bodyComponent)
        })
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  },
  UPDATE_BODY_COMPONENT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('bodies')
        .doc(payload.bodySlug)
        .collection('components')
        .doc(String(payload.bodyClass.slug))
        .update({
          components: payload.bodyClass.components
        })
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  },
  GET_BODY_COMPONENTS ({ commit }, slug) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('bodies').doc(slug).collection('components')
      let unsub = ref.onSnapshot(snapshot => {
        let bodyComponents = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          bodyComponents.push(log)
        })
        commit('SET_MANAGERS_COMPONENTS', bodyComponents)
      }, (error) => {
        reject(error)
      })
      resolve(unsub)
    })
  }
}

const getters = {
  visibleManagers: state => state.managers.filter(m => !m.hidden)
}

const mutations = {
  SET_LOADED_BODIES (state, payload) {
    state.bodies = payload
  },
  SET_MANAGERS_BODY (state, payload) {
    state.body = payload
  },
  SET_MANAGERS_COMPONENTS (state, payload) {
    state.bodyComponents = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
